(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kjs-delivery-picker"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('kjs-delivery-picker')) return;
  const area = [[13.296295,-59.56994],[13.220371,-59.523248],[13.169029,-59.426019],[13.145494,-59.415033],[13.096276,-59.445245],[13.048119,-59.504022],[13.042232,-59.528192],[13.048119,-59.541375],[13.059891,-59.545221],[13.060962,-59.568841],[13.075409,-59.614984],[13.101626,-59.636407],[13.148168,-59.643548],[13.308591,-59.654534],[13.333179,-59.633111],[13.338524,-59.614434],[13.322489,-59.58587]];
  const keys = ['KJS delivery method','KJS delivery coordinates','KJS delivery address','KJS delivery instructions','KJS delivery confirmed at','KJS delivery directions'];
  let mapsPromise, mapsFailed = false, busy = false, revision = 0;
  window.addEventListener('pageshow',event=>{
    if(!event.persisted||Number(window.Shopify?.theme?.id)!==151947575473)return;
    const config=document.querySelector('kjs-delivery-picker [data-config]');
    if(config&&JSON.parse(config.textContent).linkedCheckout)location.reload();
  });
  const inside = (lat,lng) => {
    let result = false;
    for (let i=0,j=area.length-1;i<area.length;j=i++) {
      const [yi,xi]=area[i], [yj,xj]=area[j];
      if ((yi>lat)!==(yj>lat) && lng < (xj-xi)*(lat-yi)/(yj-yi)+xi) result=!result;
    }
    return result;
  };
  async function request(url, options={}) {
    const response=await fetch(url,{credentials:'same-origin',cache:'no-store',...options,headers:{'Accept':'application/json','Content-Type':'application/json',...options.headers},signal:AbortSignal.timeout(12000)});
    if (!response.ok){const error=Error('Request failed');error.status=response.status;throw error;}
    return response.json();
  }
  function maps(apiKey) {
    if (mapsFailed) return Promise.reject(Error('Map unavailable'));
    if (window.google?.maps?.Map) return Promise.resolve(window.google.maps);
    if (mapsPromise) return mapsPromise;
    mapsPromise=new Promise((resolve,reject)=>{
      if (!apiKey) return reject(Error('Map not configured'));
      const script=document.createElement('script');
      const timer=setTimeout(()=>reject(Error('Map timeout')),15000);
      const previous=window.gm_authFailure;
      window.gm_authFailure=()=>{clearTimeout(timer);mapsFailed=true;reject(Error('Map authorization failed'));window.dispatchEvent(new Event('kjs:map-failed'));if(typeof previous==='function')previous();};
      window.kjsDeliveryMapsReady=()=>{clearTimeout(timer);resolve(google.maps);};
      script.src='https://maps.googleapis.com/maps/api/js?key='+encodeURIComponent(apiKey)+'&loading=async&callback=kjsDeliveryMapsReady&v=weekly&region=BB';
      script.async=true;
      script.onerror=()=>{clearTimeout(timer);reject(Error('Map load failed'));};
      document.head.appendChild(script);
    });
    return mapsPromise;
  }
  class DeliveryPicker extends HTMLElement {
    connectedCallback() {
      if(this.bound){this.listen();this.restore();return;}
      this.bound=true;
      this.config=JSON.parse(this.querySelector('[data-config]').textContent);
      this.copy=this.config.copy;
      this.method=''; this.pin=null; this.confirmed=false; this.saved=null; this.selectedId=null;this.editor=true;this.auth='unknown';this.savedLoading=false;
      this.locationChoicesOpen=false;
      this.addEventListener('click',event=>{
        const target=event.target.closest('button'); if(!target || busy)return;
        if(target.dataset.method)this.choose(target.dataset.method);
        if(target.hasAttribute('data-geolocate'))this.geolocate();
        if(target.hasAttribute('data-search'))this.search();
        if(target.hasAttribute('data-continue'))this.checkout();
        if(target.hasAttribute('data-load-saved'))this.loadSaved();
        if(target.hasAttribute('data-show-saved')){this.locationChoicesOpen=true;this.editor=false;this.field('save-account').checked=false;this.render();this.field('saved').querySelector('button')?.focus();}
        if(target.hasAttribute('data-change-location')){this.locationChoicesOpen=true;this.editor=!this.saved?.saved?.locations?.length;this.render();if(this.editor){this.initMap();this.field('address').focus();}else this.field('saved').querySelector('button')?.focus();}
        if(target.hasAttribute('data-new-location')){this.selectedId=null;this.editor=true;this.field('save-account').checked=false;this.field('label').value='';this.field('default').checked=false;this.field('address').value='';this.pin=null;this.marker?.setMap(null);this.marker=null;this.confirmed=false;this.fallback=null;revision++;this.render();this.initMap();this.field('address').focus();}
        if(target.hasAttribute('data-retry-map'))location.reload();
      });
      for(const field of this.querySelectorAll('[data-address],[data-instructions]'))field.addEventListener('input',()=>{revision++;this.fallback=null;this.confirmed=false;this.status(this.pin?this.copy.confirm_pin:this.copy.select_pin);this.render();});
      this.field('save-account').addEventListener('change',()=>this.render());
      this.addEventListener('keydown',event=>{if(event.key==='Enter'&&event.target.matches('input')){event.preventDefault();if(event.target.hasAttribute('data-address'))this.search();}});
      this.closest('form')?.addEventListener('submit',event=>{
        if(event.submitter?.name==='update')return;
        event.preventDefault();this.checkout();
      });
      this.sync=event=>{if(event.detail?.source!==this&&this.isConnected&&!busy)this.restore();};
      this.mapFailure=()=>{if(this.method==='delivery'){this.confirmed=false;this.status(this.copy.map_error);this.field('retry-map').hidden=false;this.render();}};
      this.listen();
      this.restore();
    }
    listen(){
      window.addEventListener('pageshow',this.sync);
      window.addEventListener('kjs:delivery-updated',this.sync);
      window.addEventListener('kjs:map-failed',this.mapFailure);
    }
    disconnectedCallback(){window.removeEventListener('pageshow',this.sync);window.removeEventListener('kjs:delivery-updated',this.sync);window.removeEventListener('kjs:map-failed',this.mapFailure);this.mapObserver?.disconnect();}
    broadcast(){revision++;window.dispatchEvent(new CustomEvent('kjs:delivery-updated',{detail:{source:this}}));}
    field(name){return this.querySelector('[data-'+name+']');}
    url(path){return this.config.root.replace(/\/?$/,'/')+path.replace(/^\//,'');}
    status(message){this.field('status').textContent=message;this.field('action-status').textContent=message;this.field('action-status').hidden=false;}
    render(){
      for(const button of this.querySelectorAll('[data-method]'))button.setAttribute('aria-pressed',String(button.dataset.method===this.method));
      this.field('map-panel').hidden=this.method!=='delivery';
      const choosing=!this.pin||this.locationChoicesOpen||this.editor;
      if(choosing)this.setAttribute('data-location-open','');else this.removeAttribute('data-location-open');
      this.field('editor').hidden=!this.editor;
      this.field('saved').hidden=!choosing||this.editor;
      this.field('new-location').hidden=!choosing||this.editor||!this.saved?.saved?.locations?.length;
      this.field('show-saved').hidden=!this.editor||!this.saved?.saved?.locations?.length;
      this.field('location-summary').hidden=!this.pin||choosing;
      const selectedLocation=this.saved?.saved?.locations?.find(item=>item.id===this.selectedId);
      const destination=selectedLocation?.label||this.field('address').value.trim()||this.copy.pin_selected;
      this.field('location-summary-text').textContent=destination;
      this.field('account-controls').hidden=this.auth!=='signed-in'||(!this.editor&&(!this.pin||Boolean(this.selectedId)));
      this.field('save-fields').hidden=!this.field('save-account').checked;
      this.field('note-panel').hidden=!this.method;
      this.field('note-label').textContent=this.method==='delivery'?this.copy.instructions:this.copy.order_note;
      this.field('note-input-label').textContent=this.field('note-label').textContent;
      this.field('selected').hidden=!this.pin||!choosing;
      this.field('selected').textContent=this.pin?this.copy.selected+' '+(this.field('address').value.trim()||this.copy.pin_selected):'';
      this.field('continue').disabled=busy || Boolean(window.KjsCartControls?.busy) || !this.method || (this.method==='delivery'&&(!this.pin||mapsFailed));
      this.field('continue').textContent=this.progress|| (this.fallback?this.copy[this.method+'_fallback_button']:this.copy.continue);
      this.field('checkout-hint').textContent=this.method==='pickup'?this.copy.pickup_hint:this.method==='delivery'?this.copy.delivery_hint:'';
      this.field('method-summary').textContent=this.method==='pickup'?this.copy.continue_pickup:this.method==='delivery'&&this.pin?this.copy.delivery_to+' '+destination:'';
      const normalMessages=[this.copy.pickup_ready,this.copy.pin_ready,this.copy.confirm_pin,this.copy.saved_ok];
      this.field('action-status').hidden=normalMessages.includes(this.field('action-status').textContent);
    }
    async locked(action){
      if(busy)return;busy=true;revision++;
      document.querySelectorAll('kjs-delivery-picker').forEach(p=>{p.setAttribute('aria-busy','true');p.render();});
      try{await action();}finally{revision++;busy=false;document.querySelectorAll('kjs-delivery-picker').forEach(p=>{p.removeAttribute('aria-busy');p.render();});}
    }
    async restore(){
      const expectedRevision=revision, restoreId=this.restoreId=(this.restoreId||0)+1;
      try{
        const cart=await request(this.url('cart.js'));
        if(!this.isConnected||busy||expectedRevision!==revision||restoreId!==this.restoreId)return;
        const a=cart.attributes||{};
        this.fallback=null;
        this.method=['pickup','delivery'].includes(a[keys[0]])?a[keys[0]]:'';
        const pair=String(a[keys[1]]||'').split(',').map(Number);
        this.pin=pair.length===2&&pair.every(Number.isFinite)&&inside(pair[0],pair[1])?{lat:pair[0],lng:pair[1]}:null;
        if(!this.pin&&this.marker){this.marker.setMap(null);this.marker=null;}
        this.confirmed=this.method==='pickup'||Boolean(this.pin&&a[keys[4]]);
        this.field('address').value=a[keys[2]]||'';
        const note=cart.note||'',old=a[keys[3]]||'';
        this.field('instructions').value=note&&old&&note!==old&&!note.includes(old)?note+'\n'+old:note||old;
        this.field('note-panel').open=Boolean(this.field('instructions').value.trim());
        this.selectedId=null;this.locationChoicesOpen=false;this.editor=this.method==='delivery'&&!this.pin;
        this.updateSubtotal(cart);
        this.status(this.method==='pickup'?this.copy.pickup_ready:this.confirmed?this.copy.pin_ready:this.method==='delivery'?(this.pin?this.copy.confirm_pin:this.copy.select_pin):this.copy.choose);
        this.render();if(this.method==='delivery'){if(this.editor)this.initMap();this.loadSaved();}
      }catch{if(expectedRevision!==revision||restoreId!==this.restoreId)return;this.status(this.copy.save_error);this.confirmed=false;this.render();}
    }
    async writeCart(method,pin){
      const attributes=Object.fromEntries(keys.map(k=>[k,'']));attributes[keys[0]]=method;
      if(method==='delivery'&&pin){
        attributes[keys[1]]=pin.lat.toFixed(6)+', '+pin.lng.toFixed(6);
        attributes[keys[2]]=this.field('address').value.trim();
        attributes[keys[3]]=this.field('instructions').value.trim();
        attributes[keys[4]]=new Date().toISOString();
        attributes[keys[5]]='https://www.google.com/maps/dir/?api=1&destination='+encodeURIComponent(attributes[keys[1]]);
      }
      const cart=await request(this.url('cart.js'));
      const updates={};
      for(const item of cart.items||[])if(String(item.product_id)==='9119770083505')updates[item.key]=0;
      const note=this.field('instructions').value.trim();
      const result=await request(this.url('cart/update.js'),{method:'POST',body:JSON.stringify({attributes,updates,note})});
      if(keys.some(k=>String(result.attributes?.[k]||'')!==attributes[k]))throw Error('Cart save not confirmed');
      if((result.items||[]).some(i=>String(i.product_id)==='9119770083505'))throw Error('Legacy helper still present');
      if(String(result.note||'')!==note)throw Error('Note save not confirmed');
      this.updateSubtotal(result);
      return result;
    }
    updateSubtotal(cart){if(Number.isFinite(cart.total_price))this.field('subtotal').textContent=new Intl.NumberFormat('en-BB',{style:'currency',currency:cart.currency||this.config.currency||'BBD',currencyDisplay:'code'}).format(cart.total_price/100);}
    async choose(method){
      if(busy||!['pickup','delivery'].includes(method))return;
      if(method===this.method){if(method==='delivery'&&this.editor)this.initMap();this.render();return;}
      await this.locked(async()=>{
        this.method=method;this.confirmed=false;this.pin=null;this.fallback=null;
        this.selectedId=null;this.locationChoicesOpen=false;this.editor=!this.saved?.saved?.locations?.length;this.field('save-account').checked=false;this.field('note-panel').open=Boolean(this.field('instructions').value.trim());
        if(this.marker){this.marker.setMap(null);this.marker=null;}
        this.field('results').replaceChildren();this.render();
        try{await this.writeCart(method,null);this.confirmed=method==='pickup';this.status(method==='pickup'?this.copy.pickup_ready:this.copy.select_pin);}catch{this.method='';this.status(this.copy.save_error);}
      });
      if(this.method==='delivery'){if(this.editor)this.initMap();this.loadSaved();}
      this.broadcast();
    }
    async initMap(){
      try{
        const gm=await maps(this.config.key);if(!this.isConnected)return;
        if(!this.map){
          this.mapObserver=new MutationObserver(()=>{
            const failed=this.field('map').querySelector('a[href="http://g.co/dev/maps-no-account"],.gm-err-container');
            if(failed){this.mapObserver.disconnect();mapsFailed=true;window.dispatchEvent(new Event('kjs:map-failed'));}
          });
          this.mapObserver.observe(this.field('map'),{childList:true,subtree:true});
          this.map=new gm.Map(this.field('map'),{center:this.pin||{lat:13.1939,lng:-59.5432},zoom:11,streetViewControl:false,mapTypeControl:false,fullscreenControl:false,gestureHandling:'cooperative'});
          new gm.Polygon({paths:area.map(([lat,lng])=>({lat,lng})),strokeColor:'#145b3b',fillOpacity:.05,clickable:false,map:this.map});
          this.map.addListener('click',event=>this.setPin({lat:event.latLng.lat(),lng:event.latLng.lng()}));
        }
        if(this.pin)this.drawPin();
      }catch{this.mapFailure();}
    }
    drawPin(){
      if(!this.map||!this.pin)return;
      if(!this.marker){this.marker=new google.maps.Marker({map:this.map,draggable:true,position:this.pin});this.marker.addListener('dragend',event=>this.setPin({lat:event.latLng.lat(),lng:event.latLng.lng()}));}
      else this.marker.setPosition(this.pin);
      this.map.panTo(this.pin);
    }
    setPin(pin){
      if(busy||mapsFailed||this.method!=='delivery')return;
      revision++;
      this.fallback=null;
      this.confirmed=false;
      if(!inside(pin.lat,pin.lng)){this.pin=null;this.marker?.setMap(null);this.marker=null;this.status(this.copy.outside);this.render();return;}
      this.pin=pin;this.editor=false;this.locationChoicesOpen=false;this.drawPin();this.status(this.copy.confirm_pin);this.render();this.field('change-location').focus();
    }
    geolocate(){
      if(!navigator.geolocation)return this.status(this.copy.geo_error);
      this.status(this.copy.locating);
      navigator.geolocation.getCurrentPosition(p=>this.setPin({lat:p.coords.latitude,lng:p.coords.longitude}),()=>this.status(this.copy.geo_error),{timeout:12000,maximumAge:0,enableHighAccuracy:true});
    }
    async search(){
      const address=this.field('address').value.trim();if(!address)return;
      this.status(this.copy.searching);
      try{
        await maps(this.config.key);
        const {results}=await new google.maps.Geocoder().geocode({address,componentRestrictions:{country:'BB'}});
        const list=this.field('results');list.replaceChildren();
        for(const result of results.slice(0,5)){
          const pin={lat:result.geometry.location.lat(),lng:result.geometry.location.lng()};if(!inside(pin.lat,pin.lng))continue;
          const b=document.createElement('button');b.type='button';b.textContent=result.formatted_address;
          b.addEventListener('click',()=>{if(busy)return;this.field('address').value=result.formatted_address.slice(0,240);this.setPin(pin);list.replaceChildren();});list.append(b);
        }
        this.status(list.children.length?this.copy.select_pin:this.copy.search_empty);
      }catch{this.status(this.copy.search_empty);}
    }
    async loadSaved(){
      if(this.savedLoading)return;this.savedLoading=true;this.field('saved-status').textContent=this.copy.loading_saved;this.field('load-saved').hidden=true;this.field('sign-in').hidden=true;
      try{this.saved=await request(this.url(this.config.proxy));this.auth='signed-in';this.field('saved-status').textContent=this.saved.saved.locations.length?'':this.copy.saved_empty;if(this.pin&&!this.selectedId&&!this.field('save-account').checked){const match=this.saved.saved.locations.find(item=>Math.abs(item.lat-this.pin.lat)<0.000002&&Math.abs(item.lng-this.pin.lng)<0.000002);this.selectedId=match?.id||null;}if(!this.pin&&!this.field('address').value&&!this.field('save-account').checked)this.editor=!this.saved.saved.locations.length;this.renderSaved();}
      catch(error){this.saved=null;this.field('saved').replaceChildren();this.auth=error.status===401&&!this.config.signedIn?'guest':'unavailable';this.field('sign-in').hidden=this.auth!=='guest';this.field('saved-status').textContent=this.auth==='guest'?'':this.copy.saved_error;this.field('load-saved').hidden=this.auth==='guest';this.editor=!this.pin;}
      finally{this.savedLoading=false;this.render();if(this.method==='delivery'&&this.editor)this.initMap();}
    }
    renderSaved(){
      const parent=this.field('saved');parent.replaceChildren();
      for(const item of this.saved.saved.locations){
        const row=document.createElement('div'),use=document.createElement('button'),edit=document.createElement('button'),remove=document.createElement('button'),label=document.createElement('strong'),address=document.createElement('span'),actions=document.createElement('div');
        row.className='kjs-delivery-picker__saved-card'+(this.selectedId===item.id?' is-selected':'');actions.className='kjs-delivery-picker__saved-actions';use.className='kjs-delivery-picker__saved-use';
        use.type=edit.type=remove.type='button';label.textContent=(this.selectedId===item.id?'✓ ':'')+item.label+(item.isDefault?' · '+this.copy.default_badge:'');address.textContent=this.selectedId===item.id?this.copy.selected_badge:item.address||this.copy.saved_location;use.append(label,address);remove.textContent=this.copy.remove;edit.textContent=this.copy.edit;
        use.setAttribute('aria-pressed',String(this.selectedId===item.id));
        remove.setAttribute('aria-label',this.copy.remove+' '+item.label);
        const select=()=>{this.selectedId=item.id;this.field('address').value=item.address;if(!this.field('instructions').value)this.field('instructions').value=item.instructions;this.field('label').value=item.label;this.field('default').checked=item.isDefault;this.setPin({lat:item.lat,lng:item.lng});};
        use.addEventListener('click',()=>{if(busy)return;this.editor=false;this.locationChoicesOpen=false;this.field('save-account').checked=false;select();this.field('note-panel').open=Boolean(this.field('instructions').value.trim());this.renderSaved();this.field('change-location').focus();});
        edit.setAttribute('aria-label',this.copy.edit+' '+item.label);
        edit.addEventListener('click',()=>{if(busy)return;select();this.editor=true;this.locationChoicesOpen=true;this.field('save-account').checked=true;this.renderSaved();this.initMap();this.field('address').focus();});
        remove.addEventListener('click',()=>{if(busy)return;if(remove.dataset.confirm!=='true'){remove.dataset.confirm='true';remove.textContent=this.copy.delete_confirm;return;}this.deleteSavedLocation(item.id);});
        actions.append(edit,remove);row.append(use,actions);parent.append(row);
      }
      this.render();
    }
    async saveList(locations){
      this.saved=await request(this.url(this.config.proxy),{method:'POST',body:JSON.stringify({saved:{version:1,locations},digest:this.saved.digest,csrf:this.saved.csrf})});this.renderSaved();
    }
    async deleteSavedLocation(id){
      if(busy)return;
      let openEditor=false;
      await this.locked(async()=>{
        const removed=this.saved.saved.locations.find(item=>item.id===id);
        if(!removed)return;
        const selected=this.selectedId===id||(this.pin&&Math.abs(removed.lat-this.pin.lat)<0.000002&&Math.abs(removed.lng-this.pin.lng)<0.000002);
        try{await this.saveList(this.saved.saved.locations.filter(item=>item.id!==id));}
        catch{this.field('saved-status').textContent=this.copy.saved_error;return;}
        const empty=this.saved.saved.locations.length===0;
        this.field('saved-status').textContent=empty?this.copy.saved_empty:'';
        if(empty||selected){
          this.selectedId=null;this.pin=null;this.confirmed=false;this.fallback=null;
          this.marker?.setMap(null);this.marker=null;
          this.field('address').value='';this.field('label').value='';this.field('default').checked=false;this.field('save-account').checked=false;this.field('results').replaceChildren();
          this.locationChoicesOpen=true;this.editor=empty;openEditor=empty;
          this.status(this.copy.select_pin);
          if(this.method==='delivery'){
            try{await this.writeCart('delivery',null);this.broadcast();}
            catch{this.status(this.copy.save_error);}
          }
        }
        this.renderSaved();
      });
      if(openEditor&&this.method==='delivery'){this.initMap();this.field('address').focus();}
    }
    async confirm(){
      if(mapsFailed||this.method!=='delivery'||!this.pin||!inside(this.pin.lat,this.pin.lng))return;
      this.accountSaveFailed=false;this.progress=this.copy.saving;this.status(this.copy.saving);
      await this.locked(async()=>{
        try{await this.writeCart('delivery',this.pin);this.confirmed=true;this.status(this.copy.pin_ready);}catch{this.confirmed=false;this.status(this.copy.save_error);return;}
        if(this.field('save-account').checked){
          try{
            if(!this.saved)this.saved=await request(this.url(this.config.proxy));
            const entry={id:this.selectedId||crypto.randomUUID(),label:this.field('label').value.trim(),...this.pin,address:this.field('address').value.trim(),instructions:this.field('instructions').value.trim().slice(0,500),isDefault:this.field('default').checked};
            const others=this.saved.saved.locations.filter(l=>l.id!==entry.id).map(l=>entry.isDefault?{...l,isDefault:false}:l);
            await this.saveList([...others,entry]);this.selectedId=entry.id;this.status(this.copy.saved_ok);
          }catch{this.accountSaveFailed=true;this.field('save-account').checked=false;this.status(this.copy.pin_ready+' '+this.copy.saved_error);}
        }
      });
      this.progress=null;this.render();
      if(this.confirmed)this.broadcast();
      this.field('continue').focus();
    }
    snapshotInput(cart){
      // Website Ajax cart is authoritative. Never import lines from a checkout.
      if(!cart.items?.length||cart.items.length>250)throw Error('Unsupported basket size');
      if(cart.total_discount>0||cart.cart_level_discount_applications?.length)throw Error('Discounted basket requires separate testing');
      const attributes=value=>Object.entries(value||{}).filter(([,v])=>v!==null&&v!==undefined&&String(v)!=='').sort(([a],[b])=>a.localeCompare(b)).map(([key,value])=>({key,value:String(value)}));
      const lines=cart.items.map(item=>{
        if(!Number.isSafeInteger(item.variant_id)||!Number.isSafeInteger(item.quantity)||item.quantity<1||item.selling_plan_allocation||item.item_components?.length)throw Error('Unsupported line');
        return {merchandiseId:'gid://shopify/ProductVariant/'+item.variant_id,quantity:item.quantity,attributes:attributes(item.properties)};
      });
      return {lines,attributes:attributes(cart.attributes),note:cart.note||'',buyerIdentity:{countryCode:'BB',preferences:{delivery:{deliveryMethod:[this.method==='pickup'?'PICK_UP':'SHIPPING']}}}};
    }
    async snapshotCheckout(saved){
      // Only Phase 9.6 may create the rate-bound checkout, whether previewed or live.
      if(Number(window.Shopify?.theme?.id)!==151947575473)throw Error('Checkout integration unavailable');
      const input=this.snapshotInput(saved),expectedRevision=revision;
      const checkout=await request(this.url('/apps/kjs-delivery/checkouts/create'),{method:'POST',body:JSON.stringify({themeId:151947575473,input})});
      const latest=await request(this.url('cart.js'));
      if(expectedRevision!==revision||JSON.stringify(this.snapshotInput(latest))!==JSON.stringify(input))throw Error('Website basket changed; try again');
      const target=new URL(checkout.checkoutUrl);
      if(target.protocol!=='https:'||target.username||target.password||!['www.homeimprovementbb.com','homeimprovementbb.com',this.config.shop,'shopify.com'].includes(target.hostname))throw Error('Unexpected checkout URL');
      return target.href;
    }
    async checkout(){
      if(busy||window.KjsCartControls?.busy)return;
      if(!this.method||(this.method==='delivery'&&(!this.pin||mapsFailed))){this.status(!this.method?this.copy.choose:this.copy.select_pin);return;}
      const form=this.closest('form');
      if(form?.querySelector('.terms_and_conditions_wrapper input[type=checkbox]:not(:checked)')){this.status(this.copy.terms);return;}
      if(this.method==='delivery'&&this.field('save-account').checked&&!this.field('label').value.trim()){this.status(this.copy.name_required);this.field('label').focus();return;}
      if(this.method==='delivery'&&(!this.confirmed||this.field('save-account').checked)){await this.confirm();if(!this.confirmed||this.accountSaveFailed)return;}
      this.progress=this.copy.opening;this.status(this.copy.opening);
      await this.locked(async()=>{
        let stage='cart-save';
        try{
          const saved=await this.writeCart(this.method,this.method==='delivery'?this.pin:null);
          if(this.config.linkedCheckout){
            stage='quantity-delivery-checkout';
            const url=await this.snapshotCheckout(saved);
            location.assign(url);return;
          }
          if(this.fallback?.method===this.method){location.assign(this.fallback.url);return;}
          stage='cart-identity';
          if(!window.Shopify?.actions?.getCart)throw Error('Cart actions unavailable');
          const {cart}=await Shopify.actions.getCart();if(!cart?.id)throw Error('Cart missing');
          const method=this.method==='pickup'?'PICK_UP':'SHIPPING';
          const query='mutation DeliveryPreference($id: ID!, $buyer: CartBuyerIdentityInput!) { cartBuyerIdentityUpdate(cartId: $id, buyerIdentity: $buyer) { cart { checkoutUrl buyerIdentity { preferences { delivery { deliveryMethod } } } } userErrors { message } } }';
          stage='delivery-preference';
          const preference=async(delivery)=>{
            const result=await request('https://'+this.config.shop+'/api/2026-07/graphql.json',{method:'POST',credentials:'omit',body:JSON.stringify({query,variables:{id:cart.id,buyer:{preferences:{delivery}}}})});
            const payload=result.data?.cartBuyerIdentityUpdate;
            if(result.errors?.length||payload?.userErrors?.length||!payload?.cart?.checkoutUrl)throw Error('Preference failed');
            return payload;
          };
          const payload=await preference({deliveryMethod:[method]});
          stage='delivery-preference-response';
          stage='checkout-redirect';
          const url=new URL(payload.cart.checkoutUrl);
          if(url.protocol!=='https:'||!['www.homeimprovementbb.com','homeimprovementbb.com',this.config.shop,'shopify.com'].includes(url.hostname))throw Error('Unexpected checkout URL');
          if(!payload.cart.buyerIdentity?.preferences?.delivery?.deliveryMethod?.includes(method)){
            this.fallback={method:this.method,url:url.href};this.status(this.copy[this.method+'_fallback']);return;
          }
          location.assign(url.href);
        }catch(error){console.warn('KJS delivery checkout could not complete',stage,error?.name||'Error');this.status(this.copy.checkout_error);}
      });
      this.progress=null;this.render();
    }
  }
  customElements.define('kjs-delivery-picker',DeliveryPicker);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kjs-native-store-stock"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('kjs-native-store-stock')) return;
    const locationIds = new Set([
      'gid://shopify/Location/58375733425',
      'gid://shopify/Location/58373472433'
    ]);
    const stockQuery = `query KjsRetailStoreStock($variantId: ID!) {
      node(id: $variantId) {
        ... on ProductVariant {
          storeAvailability(first: 20) {
            nodes { available quantityAvailable location { id name } }
            pageInfo { hasNextPage endCursor }
          }
        }
      }
    }`;
    const variantGid = (value) => {
      const id = String(value || '');
      if (/^[1-9]\d*$/.test(id)) return `gid://shopify/ProductVariant/${id}`;
      return /^gid:\/\/shopify\/ProductVariant\/[1-9]\d*$/.test(id) ? id : null;
    };
    const resourceId = (value) => String(value || '').split('/').pop();

    class KjsNativeStoreStock extends HTMLElement {
      constructor() {
        super();
        this.requestVersion = 0;
        this.onVariantChange = (event) => {
          const detail = event.detail || {};
          if (this.dataset.instanceId && String(detail.sectionId || '') === this.dataset.instanceId && resourceId(detail.productId) === this.dataset.productId) {
            this.load(detail.variantId);
          }
        };
        this.onRetry = () => this.load(this.variantId);
      }

      connectedCallback() {
        if (this.bound) return;
        this.status = this.querySelector('[data-stock-status]');
        this.retry = this.querySelector('[data-stock-retry]');
        this.badges = Array.from(this.querySelectorAll('[data-stock-location]'));
        if (!this.status || !this.retry || this.badges.length !== 2) return;
        this.bound = true;
        this.numberFormat = new Intl.NumberFormat(document.documentElement.lang || 'en');
        document.addEventListener('kjs:variant-change', this.onVariantChange);
        this.retry.addEventListener('click', this.onRetry);
        const section = this.closest('[data-section-id]');
        const selected = section && section.dataset.sectionId === this.dataset.instanceId
          ? section.querySelector(`[id="product-select-${this.dataset.productId}"]`)
          : null;
        this.load(selected ? selected.value : this.dataset.variantId);
      }

      disconnectedCallback() {
        this.requestVersion += 1;
        if (this.controller) this.controller.abort();
        clearTimeout(this.timeout);
        document.removeEventListener('kjs:variant-change', this.onVariantChange);
        if (this.retry) this.retry.removeEventListener('click', this.onRetry);
        this.bound = false;
      }

      clearQuantities() {
        for (const badge of this.badges) {
          badge.textContent = this.dataset.checkStore;
          badge.dataset.stockState = 'unknown';
        }
      }

      setState(state, message, retry = false) {
        this.dataset.stockState = state;
        this.setAttribute('aria-busy', state === 'loading' ? 'true' : 'false');
        this.status.textContent = message;
        this.retry.hidden = !retry;
      }

      async load(value) {
        const version = ++this.requestVersion;
        if (this.controller) this.controller.abort();
        clearTimeout(this.timeout);
        this.variantId = variantGid(value);
        this.clearQuantities();
        if (!this.variantId) {
          this.setState('unavailable', this.dataset.chooseVariant);
          return;
        }
        if (!this.dataset.token || !/^https:\/\/[a-z0-9][a-z0-9-]*\.myshopify\.com\/api\/2026-07\/graphql\.json$/.test(this.dataset.endpoint || '')) {
          this.setState('unavailable', this.dataset.unavailable);
          return;
        }
        const controller = new AbortController();
        this.controller = controller;
        this.setState('loading', this.dataset.loading);
        this.timeout = setTimeout(() => controller.abort(), 10000);
        try {
          const response = await fetch(this.dataset.endpoint, {
            method: 'POST',
            mode: 'cors',
            credentials: 'omit',
            cache: 'no-store',
            headers: {
              'Content-Type': 'application/json',
              'X-Shopify-Storefront-Access-Token': this.dataset.token
            },
            body: JSON.stringify({query: stockQuery, variables: {variantId: this.variantId}}),
            signal: controller.signal
          });
          if (!response.ok) throw new Error('Stock request failed');
          const payload = await response.json();
          if (version !== this.requestVersion || !this.isConnected) return;
          if (payload.errors && payload.errors.length) throw new Error('Stock access failed');
          const connection = payload.data && payload.data.node && payload.data.node.storeAvailability;
          if (!connection || !Array.isArray(connection.nodes) || !connection.pageInfo || connection.pageInfo.hasNextPage !== false) {
            throw new Error('Incomplete stock response');
          }
          const quantities = new Map();
          for (const entry of connection.nodes) {
            const id = entry && entry.location && entry.location.id;
            if (!locationIds.has(id)) continue;
            if (quantities.has(id)) throw new Error('Duplicate stock location');
            quantities.set(id, Number.isSafeInteger(entry.quantityAvailable) && entry.quantityAvailable >= 0 ? entry.quantityAvailable : null);
          }
          for (const badge of this.badges) {
            const quantity = quantities.get(badge.dataset.stockLocation);
            if (quantity === 0) {
              badge.textContent = this.dataset.outOfStock;
              badge.dataset.stockState = 'empty';
            } else if (Number.isSafeInteger(quantity) && quantity > 0) {
              badge.textContent = this.dataset.quantityPattern.replace('__COUNT__', this.numberFormat.format(quantity));
              badge.dataset.stockState = 'in-stock';
            }
          }
          this.setState('ready', this.dataset.updated);
        } catch (_) {
          if (version === this.requestVersion && this.isConnected) {
            this.clearQuantities();
            this.setState('unavailable', this.dataset.unavailable, true);
          }
        } finally {
          if (version === this.requestVersion) clearTimeout(this.timeout);
        }
      }
    }
    customElements.define('kjs-native-store-stock', KjsNativeStoreStock);
  })();
  } catch(e) { console.error(e); }
})();

})();
